import {DATETIME} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

// Types
import {dateTime, apiDateTime} from '@drivesally/sally-fw/lib/type';

export default attribute({
  type: DATETIME,
  attribute: 'date_etc',
  display: dateTime,
  input: dateTime,
  api: apiDateTime,
  label: {
    default: 'ETC',
    short: 'ETC',
  },
  disabledDates: [{before: new Date()}],
});
